module.exports = __webpack_public_path__ + "static/media/accounting.98af9c31.svg";